import { useQueryClient } from '@tanstack/react-query';

import useToastedMutation from '../../../../ReactQuery/useToastedMutation';
import { patch } from '../../../../redux/api';
import type { SetDefaultMethodResponse } from '../../../../../shared/types/routes/auth/mfa';

import { getMfaMethodsQueryKey } from './useListMfaMethods';

/**
 * Set an MFA method as the default
 */
export default function useSetDefaultMfaMethod() {
  const queryClient = useQueryClient();

  return useToastedMutation({
    mutationFn: async (methodId: number) => {
      await patch<never, SetDefaultMethodResponse>(
        `/api/auth/mfa/methods/${methodId}/default`,
        undefined as never,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getMfaMethodsQueryKey() });
    },
    successToastMessage: 'Default MFA method updated successfully',
    errorToastMessage: 'Failed to update default MFA method',
  });
}
